export enum StorageKey {
  AccessToken = 'access_token',
  RegisterServiceWelcomeDialog = 'RegisterServiceWelcomeDialog',
  DenticareSessionId = 'denticare_session_Id',
  DenticareSessionIdBackUp = 'denticare_session_Id_backup'
}
